export const landingContactFormConstants = {
    LANDING_CONTACT_FORM_PENDING  : 'LANDING_CONTACT_FORM_PENDING',
    LANDING_CONTACT_FORM_FULFILLED: 'LANDING_CONTACT_FORM_FULFILLED',
    LANDING_CONTACT_FORM_REJECTED : 'LANDING_CONTACT_FORM_REJECTED',
    LANDING_CONTACT_FORM_CLEAR_STATE : 'LANDING_CONTACT_FORM_CLEAR_STATE',
};
